import ReactLoading from 'react-loading';

const AppLoading = ({loading} : {loading: boolean}) => {
  if (loading) {
    return (
      <div className='loading-data-wrapper'>
        <ReactLoading type='spinningBubbles' color='#d54941' />
      </div>
    );
  }
  return <></>
};

export default AppLoading;
